

//const API_BASE_URL = "http://192.168.2.5:3008/api/v1/"

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const API_PYTHON_BASE_URL = "https://recognition.appservices.com.ec:8443/"

export const APIURL = {
  SelectDato: () => `${API_BASE_URL}Cbo_EstadosGestion`,
  SelectTipoContacto: () => `${API_BASE_URL}Cbo_EstadosTipoContacto`,
  SelectTipoResultado: () => `${API_BASE_URL}Cbo_ResultadoGestion`,
  postinst: () => `${API_BASE_URL}Protecion-datos`,
  postImg: () => `${API_BASE_URL}subir-img`,
  getEstabilidadLaboral: () => `${API_BASE_URL}cre-tiempo/1`,
  getCreVerificacionTelefonica: () => `${API_BASE_URL}cre-verificacion-telefonica`,
  getCreVerificacionTelefonicaMaestro: (id) => `${API_BASE_URL}cre-verificacion-telefonica-maestro/${id}`,
  getHistorilaVerificacionTelefonica: (id) => `${API_BASE_URL}cre-verificacion-telefonica-historial/${id}`,
  getSearchCreSolicitudVerificacionTelefonica: (idCre_SolicitudWeb, idCre_VerificacionTelefonicaMaestro) => `${API_BASE_URL}cre-solicitudverificaciontelefonica/search?idCre_SolicitudWeb=${idCre_SolicitudWeb}&idCre_VerificacionTelefonicaMaestro=${idCre_VerificacionTelefonicaMaestro}`,
  getCreSolicitudCredito: () => `${API_BASE_URL}cre-solicitud-web/all-cresolicitudweb`,
  getActividadEconomina: () => `${API_BASE_URL}cre-actividadeconomina/2`,
  getTipoConsulta: () => `${API_BASE_URL}compraencuesta/1`,
  post_cre_solicitud_web: () => `${API_BASE_URL}cre-solicitud-web`,
  post_cre_solicitud_web_V2: () => `${API_BASE_URL}cre-solicitud-web/Nueva-solicitud-web`,
  get_TipoConsulta: () => `${API_BASE_URL}compraencuesta/1`,
  post_cogno_Token: (ci) => `${API_BASE_URL}auth/cogno/token/${ci}`,
  getCoordenadasprefactura: () => `${API_BASE_URL}coordenadasprefactura/all`,
  getTipodocumento: () => `${API_BASE_URL}cre-tipodocumento/findAll`,
  getTiposexo: () => `${API_BASE_URL}cre-sexo`,
  getNiveleducacion: () => `${API_BASE_URL}cre-niveleducacion`,
  getProfesion: () => `${API_BASE_URL}cre-profesion`,
  getParentesco: () => `${API_BASE_URL}cre-parentesco`,
  getProvincias: () => `${API_BASE_URL}cre-provincia`,
  getCantones: (id) => `${API_BASE_URL}cre-canton/${id}`,
  getParroquias: (id) => `${API_BASE_URL}cre-parroquia/${id}`,
  getBarrios: (id) => `${API_BASE_URL}cre-barrio/${id}`,
  getTipoCliente: () => `${API_BASE_URL}tipo-cliente`,
  getMenu: (idUsuario) => `${API_BASE_URL}menu-item-role/${idUsuario}/menu`,
  getDetalleTipoCliente: () => `${API_BASE_URL}detalle-tipo-cliente`,
  getTipoTrabajo: () => `${API_BASE_URL}tipo-trabajo`,
  getCalificacion: () => `${API_BASE_URL}cre-tipocalificacion`,
  getEstado: () => `${API_BASE_URL}cre-estado`,
  getEstadoSolicitud: (id) => `${API_BASE_URL}estado-solicitud/${id}`,
  getUsuarioBodega: () => `${API_BASE_URL}usuario-bodega/usuario/bodegas`,
  postFileupload: () => `${API_BASE_URL}file-upload/upload`,
  putUpdatesolicitud: (id) => `${API_BASE_URL}cre-solicitud-web/${id}`,
  getConsultaCre_solicitud_web: (id) => `${API_BASE_URL}cre-solicitud-web/${id}`,
  get_cre_niveleducacion: () => `${API_BASE_URL}cre-niveleducacion `,
  get_cre_profesion: () => `${API_BASE_URL}cre-profesion`,
  getVendedor: (id) => `${API_BASE_URL}nomina/Vendedor/${id}`,
  getEstadoReferencia: () => `${API_BASE_URL}crectaedogestion`,
  get_nomina: (id) => `${API_BASE_URL}nomina/${id}`,
  generateOTP: () => `${API_BASE_URL}otp/generate`,
  verifyOTP: () => `${API_BASE_URL}otp/verify`,
  get_creNacionalidad: () => `${API_BASE_URL}cre-nacionalidad`,
  get_estadoCivil: () => `${API_BASE_URL}cre-estadocivil`,
  get_cre_actividadeconomina: (idAct) => `${API_BASE_URL}cre-actividadeconomina/${idAct}`,
  get_cre_inmueble: () => `${API_BASE_URL}cre-inmueble`,
  get_cre_CiudadInmueble: () => `${API_BASE_URL}cre-ciudadinmueble`,
  get_cre_tipoVivienda: () => `${API_BASE_URL}cre-tipovivienda`,
  get_cre_tiempoVivienda: () => `${API_BASE_URL}cre-tiempovivienda`,
  getNombreTipoConsulta: (id) => `${API_BASE_URL}compraencuesta/tipo/${id}`,
  post_creVerificacionTelefonica: () => `${API_BASE_URL}creverificaciontelefonica`,
  post_documentos: () => `${API_BASE_URL}documentos-solicitud`,
  get_documentos: (id, idEstadoVerificacionDocumental) => `${API_BASE_URL}documentos-solicitud/documentos/${id}/${idEstadoVerificacionDocumental}`,
  get_documentosEstado: (id, estado) => `${API_BASE_URL}documentos-solicitud/${id}/${estado}`,
  patch_documentos: (id) => `${API_BASE_URL}documentos-solicitud/${id}`,
  patch_solicitudweb: (id) => `${API_BASE_URL}documentos-solicitud/updateEstado/${id}`,
  patch_cancelados: (id) => `${API_BASE_URL}documentos-solicitud/update-cancelados/${id}`,
  get_observaciones: (idSolicitud, idTipoDocumento) => `${API_BASE_URL}documentos-solicitud/observaciones?idSolicitud=${idSolicitud}&idTipoDocumento=${idTipoDocumento}`,
  post_observaciones: () => `${API_BASE_URL}historial-observaciones`,
  /*solicitud grande*/
  get_cre_solicitud_web: () => `${API_BASE_URL}cre-solicitud-web/`,
  get_cre_solicitud_web_id: (idSolicitud, numeroSolicitud) => `${API_BASE_URL}web-solicitudgrande/${idSolicitud}/${numeroSolicitud}`,
  puth_web_solicitudgrande_listadosolicitud: (idWeb_SolicitudGrande) => `${API_BASE_URL}web-solicitudgrande/listadosolicitud/${idWeb_SolicitudGrande}`,
  post_creSolicitudVerificacionTelefonica: () => `${API_BASE_URL}cre-solicitudverificaciontelefonica`,
  getActividadEconominasituacionLaboral: () => `${API_BASE_URL}cre-situacionlaboral`,
  getCheckDocumento: (idCreSolicitudWeb, tipoDocumento) => `${API_BASE_URL}documentos-solicitud/check?idCreSolicitudWeb=${idCreSolicitudWeb}&tipoDocumento=${tipoDocumento}`,
  get_analis_cogno: (ci) => `${API_BASE_URL}usuarios/analistas/?Filtro=${ci}`,
  get_verif_cogno: (ci) => `${API_BASE_URL}usuarios/verificadores/?Filtro=${ci}`,
  post_analista: () => `${API_BASE_URL}analistacredito`,
  post_verificador: () => `${API_BASE_URL}verificadorcredito`,
  getFechaAnalista: () => `${API_BASE_URL}fecha-analista`,
  getFechaVerificador: () => `${API_BASE_URL}fecha-verificador`,
  analistacredito: () => `${API_BASE_URL}analistacredito`,
  verificadorcredito: () => `${API_BASE_URL}verificadorcredito`,
  posthorarioanalista: () => `${API_BASE_URL}horariosanalistas`,
  posthorarioverificador: () => `${API_BASE_URL}horariosverificadores`,
  get_repositorios: (anio, mes) => {
    let url = API_BASE_URL + "cre-solicitud-web/repositorios";
    let params = [];
    if (anio != null) {
      params.push("anio=" + encodeURIComponent(anio));
    }
    if (mes != null) {
      params.push("mes=" + encodeURIComponent(mes));
    }
    if (params.length > 0) {
      url += "?" + params.join("&");
    }
    return url;
  },
  get_cre_tipoempresa: () => `${API_BASE_URL}cre-tipoempresa`,
  get_tipocontrato: () => `${API_BASE_URL}cre-tipocontrato`,
  get_cre_tiposueldo: () => `${API_BASE_URL}cre-tiposueldo`,
  get_cre_cargo: () => `${API_BASE_URL}cre-cargo`,
  post_cre_referenciasclientesweb: () => `${API_BASE_URL}cre-referenciasclientesweb`,
  get_cre_referenciasclientesweb_id: (id) => `${API_BASE_URL}cre-referenciasclientesweb/all/${id}`,
  update_soliciutd_telefonica: (id, estado) => `${API_BASE_URL}cre-solicitud-web/updatetelefonica/${id}/${estado}`,
  update_solicitud: (id) => `${API_BASE_URL}cre-solicitud-web/updatetelefonicaEstados/${id}`,
  verificarRegistroSolicitud: (cedula) => `${API_BASE_URL}cre-solicitud-web/verificar-cedula-bodega?cedula=${cedula}`,
  getIdsTerrenas: (id, tipo) => `${API_BASE_URL}clientes-verificacion-terrena/${id}/${tipo}`,
  get_info_trabajo: (id) => `${API_BASE_URL}terrena-gestion-trabajo/${id}`,
  get_horariosanalistas: () => `${API_BASE_URL}horariosanalistas`,
  get_horariosverificadores: () => `${API_BASE_URL}horariosverificadores`,
  postInsertarCoordenadasprefactura: () => `${API_BASE_URL}coordenadasprefactura/insert`,
  get_cognotrabajocargo: () => `${API_BASE_URL}cognotrabajocargo`,
  post_createtiemposolicitudeswebDto: () => `${API_BASE_URL}tiemposolicitudesweb`,
  get_tiemposolicitudesweb_all: (id) => `${API_BASE_URL}tiemposolicitudesweb/all/${id}`,
  /*   @Get('all/estado/:idCre_SolicitudWeb/:tipo')  */
  get_tiemposolicitudesweb: (id, estado) => `${API_BASE_URL}tiemposolicitudesweb/all/estado/${id}/${estado}`,
  get_TiempSolicWeb: (tipo, id, estado) => `${API_BASE_URL}tiemposolicitudesweb/tiempo/${tipo}/${id}/${estado}`,
  get_Verificador: (id) => `${API_BASE_URL}tiemposolicitudesweb/tiempo/${id}`,
  get_ingresoCobrador: () => `${API_BASE_URL}ingreso-cobrador`,
  get_ingresoCobradorZona: (idCre_SolicitudWeb, iDomicilio) => `${API_BASE_URL}ingreso-cobrador/zona/${idCre_SolicitudWeb}/${iDomicilio}`,
  post_clientesVerificacionTerrenaBasica: () => `${API_BASE_URL}clientes-verificacion-terrena/basica`,
  getCoordenadasprefacturaPorId: (id, Tipo) => `${API_BASE_URL}coordenadasprefactura/find/${id}/${Tipo}`,
  get_cre_referenciasclientesweb_id_all: (id) => `${API_BASE_URL}cre-referenciasclientesweb/all/count/${id}`,
  getTerrenaGestionDomicilio: (id) => `${API_BASE_URL}terrena-gestion-domicilio/${id}`,
  getacces: (idMenu, idUsuario) => `${API_BASE_URL}menu-item-role/permissionscomponents/${idMenu}/${idUsuario}`,
  getRolesWeb: () => `${API_BASE_URL}rolesweb`,
  getUsuarioPorROL: (idRol) => `${API_BASE_URL}usuarios/rol/${idRol}`,
  getMenuPorusuario: (idUsuario) => `${API_BASE_URL}menu-item-role/permissionsmenu/${idUsuario}`,
  deletePermisoUsuario: (idUsuario, idmenuItemRoles) => `${API_BASE_URL}menu-item-role/permisos/delete/${idUsuario}/${idmenuItemRoles}`,
  createPermisoUsuario: (idUsuario, mIdmenuItems) => `${API_BASE_URL}menu-item-role/permisos/create/${idUsuario}/${mIdmenuItems}`,
  getTodosLosAccesos: () => `${API_BASE_URL}menu-item-role/permissionscomponents`,
  getRolesAccesos: (idUsuario, idmenu_items) => `${API_BASE_URL}menu-item-role/accessroles/${idUsuario}/${idmenu_items}`,
  deleteRolesAccesos: (idUsuario, idmenu_items) => `${API_BASE_URL}menu-item-role/accessroles/delete/${idUsuario}/${idmenu_items}`,
  createRolesAccesos: (idUsuario, idmenu_items) => `${API_BASE_URL}menu-item-role/accessroles/create/${idUsuario}/${idmenu_items}`,
  listaVendedoresporBodega: (Fecha, idBodega, inivel) => `${API_BASE_URL}exec-sp/FacturacionListaVendedoresWeb/${Fecha}/${idBodega}/${inivel}`,
  getdocumentosanalista: () => `${API_BASE_URL}cre-solicitud-web/documentosanalista`,
  post_VerificacionTelefonicaMaestro: () => `${API_BASE_URL}cre-verificacion-telefonica-maestro`,
  postCompareFaces: () => `${API_PYTHON_BASE_URL}verify-faces`,
  //// LISTA NEGRA TELEFONOS
  getTelefonos: () => `${API_BASE_URL}lista-negra-cell`,
  postTelefono: () => `${API_BASE_URL}lista-negra-cell`,
  updateTelefono: (id) => `${API_BASE_URL}lista-negra-cell/${id}`,
  validarTelefono: (telefono) => `${API_BASE_URL}lista-negra-cell/telefono/${telefono}`,
  getCedulas: () => `${API_BASE_URL}lista-negra-cedula`,
  postCedula: () => `${API_BASE_URL}lista-negra-cedula`,
  updateCedula: (id) => `${API_BASE_URL}lista-negra-cedula/${id}`,
  validarCedula: (cedula) => `${API_BASE_URL}lista-negra-cedula/cedula/${cedula}`,
  validarCedulaCognos: (cedula) => `${API_BASE_URL}cre-solicitud-web/solicitud-Cogno/${cedula}`,
  analistacreditoUsuarioRol: (igrupo, analista) => `${API_BASE_URL}analistacredito/usuario/${igrupo}/${analista}`,
  getEqfxIdentificacion: (Cedula) => `${API_BASE_URL}eqfxidentificacionconsultada/${Cedula}`,
  getEqfxResultSegment: (id) => `${API_BASE_URL}eqfxResultadoSegmentacion/${id}`,
  getEqfxResultPliticas: (id) => `${API_BASE_URL}eqfxResultadoPoliticas/${id}`,
  getEqfxScorePuntaje: (id) => `${API_BASE_URL}eqfxScorePuntajeV3/${id}`,
  getVerificacionTresDocumentos: (id) => `${API_BASE_URL}documentos-solicitud/verificar-documentos-aprobados/${id}`,
  getReporteBuroCredito: (id) => `${API_BASE_URL}eqfxReporteBuroCredito/${id}`,
  patch_codDactil: (id) => `${API_BASE_URL}cre-solicitud-web/updatecodDactilar/${id}`,
  enviarNotificacion: () => `https://appservices.com.ec/cobranza/api/v1/point/NotificationUser/expo`,
  consultarNombresNotif: (id) => `${API_BASE_URL}dispositivosApp/empresa/${id}`,
  patch_CuotayCupo: (id) => `${API_BASE_URL}web-solicitudgrande/updatecuotaycupo/${id}`,
  get_Asignacion_vendedores: (id) => `${API_BASE_URL}com-asignacion-de-vendedores/jefes-de-bodega/${id}`,
  get_UsuariobyId: (id) => `${API_BASE_URL}usuarios/id/${id}`,
  get_tokenbyUsuario: (nombre) => `${API_BASE_URL}dispositivosApp/usuario/${nombre}`,
  get_tokenVendedor: (id) => `${API_BASE_URL}dispositivosApp/tokenExpo/${id}`,
  getCoordenadasId: (id, tipo) => `${API_BASE_URL}coordenadasprefactura/id/${id}/${tipo}`,

  // Verifica si el usuario ya tiene ingreso en InfoSistema
  verificarCambioClave: (usuario) => `${API_BASE_URL}info-sistema/existe/${usuario}`,

  // Registra el ingreso del usuario en InfoSistema
  registrarIngresoSistema: () => `${API_BASE_URL}info-sistema/registrar`,

  // Cambiar contraseña del usuario
  cambiarClave: () => `${API_BASE_URL}usuarios/cambiar-clave`,
  recuperarClave: () => `${API_BASE_URL}usuarios/recuperar-clave`,
  patch_ClientesVerifTerren: (id) => `${API_BASE_URL}clientes-verificacion-terrena/update/${id}`,

  get_ClientesVerifTerrenporId: (id) => `${API_BASE_URL}clientes-verificacion-terrena/allbyID/${id}`,
  get_CoordenadasInforme: (id) => `${API_BASE_URL}clientes-verificacion-terrena/coordInforme/${id}`,

  // Endpoints para Lista Negra de Emails
  getEmails: () => `${API_BASE_URL}lista-negra-email`,
  postEmail: () => `${API_BASE_URL}lista-negra-email`,
  updateEmail: (id) => `${API_BASE_URL}lista-negra-email/${id}`,
  deleteEmail: (id) => `${API_BASE_URL}lista-negra-email/${id}`,
  getEmailById: (id) => `${API_BASE_URL}lista-negra-email/${id}`,
  validarEmail: (email) => `${API_BASE_URL}lista-negra-email/email/${email}`,

  store_reports_phone_verification: (id) => `${API_BASE_URL}store-reports-phone-verification/cre-solicitud/${id}`,
  patchTipoVerificacionDomicilio: (id) => `${API_BASE_URL}terrena-gestion-domicilio/${id}/tipo-verificacion`,

  get_Productos: () => `${API_BASE_URL}cre-producto-solicitud`,

  get_reporteCeditoDirecto: (id) => `${API_BASE_URL}basic-reports/credito-directo/${id}`,

  get_excelSolicitudWeb: ({ BodegaId, FechaDesde, FechaHasta } = {}) => {
    let url = `${API_BASE_URL}excel-solicitudes-web/export-excel`
    const params = [];

    if (BodegaId) params.push(`BodegaId=${BodegaId}`);
    if (FechaDesde) params.push(`FechaDesde=${FechaDesde}`);
    if (FechaHasta) params.push(`FechaHasta=${FechaHasta}`);

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return url;
  },
  get_motivosContinuidad: () => `${API_BASE_URL}motivo-continuidad`,
  get_Count_get_motivosContinuidad: (vendedor) => `${API_BASE_URL}cre-solicitud-web/MotivoContinuidad/${vendedor}`,
  get_Count_get_motivosContinuidad_Bodega: (bodega) => `${API_BASE_URL}cre-solicitud-web/MotivoContinuidad-almacen/${bodega}`,
  patchTipoVerificacionTrabajo: (id) => `${API_BASE_URL}terrena-gestion-trabajo/tipo-verificacion/${id}`,
  update_VerificacionTelefonicaMaestro: (id) => `${API_BASE_URL}cre-verificacion-telefonica-maestro/${id}`,
  validaPrefactura: (NumeroIdentificacion, Bodega) => `${API_BASE_URL}compra/ValidaEstadoCompra/${NumeroIdentificacion}/${Bodega}`,
  getSolicitudGrandeporId: (id) => `${API_BASE_URL}web-solicitudgrande/${id}`,
  getUatReporteBuroCredito: (id) => `${API_BASE_URL}uatEqfxReporteBuroCredito/${id}`,
  getCliente: (cedula) => `${API_BASE_URL}cliente/cedula/${cedula}`,
  postGeoreferenciaEntregaDomicilio: () => `${API_BASE_URL}georeferencia-entrega-domicilio`,
  patch_EstadoRegcivil: (id) => `${API_BASE_URL}cre-solicitud-web/updateEstadozz/${id}`, //endpoint provicional registro civil
  personal_bdd_findAllgestor: () => `${API_BASE_URL}personal-bdd/gestores`,
  cre_entidad_financiera_findAllCobranza: (activo) => `${API_BASE_URL}cre-entidad-financiera/findAllCobranza/${activo}`,
  serviciosia365pro_biometric: () => `${API_BASE_URL}corporacion-dfl/serviciosia365pro/biometrico`,
  //infoanalisisIdentidad: (dni,id) => `${API_BASE_URL}analisisdeidentidad/find-all/${dni}`,

  //documentos
  getContratoCompraVenta: () => `${API_BASE_URL}store-reports-phone-verification/compraVenta-resDominio`,
  getDeclaracion: (id) => `${API_BASE_URL}store-reports-phone-verification/declaracion-compromiso/${id}`,
  getPagareOrden: (id) => `${API_BASE_URL}store-reports-phone-verification/pagare-orden/${id}`,
  getTablaAmortizacion: (id) => `${API_BASE_URL}store-reports-phone-verification/tabla-amortizacion/${id}`,
  getGastosCobranza: (id) => `${API_BASE_URL}store-reports-phone-verification/gastos-cobranza/${id}`,
  getCompromisoLugarPago: (id) => `${API_BASE_URL}store-reports-phone-verification/compromiso-lugarPag/${id}`,
  getActa: (id) => `${API_BASE_URL}store-reports-phone-verification/entrega-datos/${id}`,
  getConsentimiento: (id) => `${API_BASE_URL}store-reports-phone-verification/tratamiento-datos/${id}`,
  getAutorizacion: (id) => `${API_BASE_URL}store-reports-phone-verification/compraVenta-resDominio`,
  infoanalisisIdentidad: (dni) => `${API_BASE_URL}analisisdeidentidad/find-all/${dni}`,
  serviciosia365pro_biometric_firma: () => `${API_BASE_URL}corporacion-dfl/serviciosia365pro/biometrico/crear-firma-digital`,
  /*http://192.168.2.20:3008/api/v1/cbo-gestores-cobranzas-operativo?desdeDiasMora=10&hastaDiasMora=90&cobradorOperador=0&idOperadorCobrador=0&gestionados=1&idCbo_ResultadoGestion=0&pageNumber=1&pageSize=50*/
  postMensajescobranza: () => `${API_BASE_URL}otp/smsmasivo`,
  cbo_gestores_cobranzas_operativo: (desdeDiasMora, hastaDiasMora, cobradorOperador, idOperadorCobrador, gestionados, idCbo_ResultadoGestion, idCbo_Gestores, gestionHoy, Nombre, pageNumber, pageSize,) => `${API_BASE_URL}cbo-gestores-cobranzas-operativo?desdeDiasMora=${desdeDiasMora}&hastaDiasMora=${hastaDiasMora}&cobradorOperador=${cobradorOperador}&idOperadorCobrador=${idOperadorCobrador}&gestionados=${gestionados}&idCbo_ResultadoGestion=${idCbo_ResultadoGestion}&idGestores=${idCbo_Gestores}&GestionHoy=${gestionHoy}&Filtro=${Nombre}&pageNumber=${pageNumber}&pageSize=${pageSize}`,
  Cbo_GestorDeCobranzasOperativodet: (ScRE_SOLIICTUDwEB) => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/detalle?ScRE_SOLIICTUDwEB=${ScRE_SOLIICTUDwEB}`,
  getDetalleGestoresCobranzasDetalleOperativoWeb: (idCompra) => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/detalle-web?idCompra=${idCompra}`,
  SaveGestion: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/new-insert-data`,
  getViewTablaAmortizacion: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/tabla-amortizacion`,
  getViewTablaAmortizacionValores: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/tabla-amortizacion-valores`,
  listTablaPagosAmortizacion: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/tabla-amortizacion-valores/detalle-pagos`,
  findAllCbo_Gestores: () => `${API_BASE_URL}Cbo_Gestores`,
  cbo_scores_cobranzaFindAll: () => `${API_BASE_URL}cbo-scores-cobranza`,
  cbo_riesgos_findBy: (cbo_gestorRiesgo) => `${API_BASE_URL}cbo-riesgos?cbo_gestorRiesgo=${cbo_gestorRiesgo}`,
  cbo_segmentos_findBy: (scoreId) => `${API_BASE_URL}cbo-segmentos?cbo_segmento=${scoreId}`,
  cbo_almacenes_findBy: (scoreId) => `${API_BASE_URL}cbo-almacenes?cbo-almacenes=${scoreId}`,
  cbo_tipo_cliente: (sCbo_Scores_Cobranzas) => `${API_BASE_URL}cbo-tipo-cliente?sCbo_Scores_Cobranzas=${sCbo_Scores_Cobranzas}`,
  cbo_edad_findBy: (sCbo_Scores_Cobranzas) => `${API_BASE_URL}cbo-edad?sCbo_Scores_Cobranzas=${sCbo_Scores_Cobranzas}`,
  cbo_Saldos: (sCbo_Scores_Cobranzas) => `${API_BASE_URL}cbo-saldos?sCbo_Scores_Cobranzas=${sCbo_Scores_Cobranzas}`,
  cbo_Score_Resultado: (sCbo_Scores_Cobranzas) => `${API_BASE_URL}cbo-score-resultado?sCbo_Scores_Cobranzas=${sCbo_Scores_Cobranzas}`,
  porcentaje_cobranza: (ScRE_SOLIICTUDwEB) => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/porcentaje-cobranza?ScRE_SOLIICTUDwEB=${ScRE_SOLIICTUDwEB}`,
  cbo_FlujoDeCobranzasFindAll: () => `${API_BASE_URL}cbo-flujodecobranzas/all`,
  cbo_tipoCarteraFindAll: (period) => `${API_BASE_URL}cbo-tipocartera?period=${period}`,
  cbo_riesgofindall: () => `${API_BASE_URL}cbo-riesgo`,
  Cbo_ResultadoGestionInnerJoin: () => `${API_BASE_URL}Cbo_ResultadoGestion/estados-activos`,
  patchcbo_flujodecobranzas: (id) => `${API_BASE_URL}cbo-flujodecobranzas/${id}`,
  deletecbo_flujodecobranzas: (id) => `${API_BASE_URL}cbo-flujodecobranzas/delete/${id}`,
  postcbo_flujodecobranzas: () => `${API_BASE_URL}cbo-flujodecobranzas/new-insert-data`,
  getcbo_acciones_all: () => `${API_BASE_URL}cbo-acciones`,
  post_cbo_acciones: () => `${API_BASE_URL}cbo-acciones/new-record`,
  patch_cbo_acciones: (id) => `${API_BASE_URL}cbo-acciones/update-record/${id}`,
  delete_cbo_acciones: (id) => `${API_BASE_URL}cbo-acciones/delete-record/${id}`,
  getMensajesMassend: () => `${API_BASE_URL}mensajemassend`,
  createAccionCobranza: () => `${API_BASE_URL}cbo-acciones-cobranza`,
  getAccionesCobranzas: (flujoId) => `${API_BASE_URL}cbo-acciones-cobranza/${flujoId}`,
  updateAccionCobranza: (sCbo_FlujoDeCobranzas, idCbo_AccionesCobranzas) => `${API_BASE_URL}cbo-acciones-cobranza/${sCbo_FlujoDeCobranzas}/${idCbo_AccionesCobranzas}`,
  deletecbo_Acciones: (sCbo_FlujoDeCobranzas, idCbo_AccionesCobranzas) => `${API_BASE_URL}cbo-acciones-cobranza/${sCbo_FlujoDeCobranzas}/${idCbo_AccionesCobranzas}`,
  get_motivosContinuidadRecurrente: () => `${API_BASE_URL}motivo-continuidad/estadorecurrente`,
  gestionesrecurrentesinsert: () => `${API_BASE_URL}gestionesrecurrentes/new-gestion`,
  postviewcbogestorescobranzasoperativo: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/det-cliente-gestion-base`,
  usuario_bodega_bodega_user: () => `${API_BASE_URL}usuario-bodega/bodega-user`,
  asigancionvendedoresforbodega: (id) => `${API_BASE_URL}com-asignacion-de-vendedores/vendedores-for-bodega/${id}`,
  clientes_gestion_base_periodo: (periodo) => `${API_BASE_URL}clientes-gestion-base/periodo/${periodo}`,
  getClientesRescatados: (codigo) => `${API_BASE_URL}creRescateclientes/clientes/${codigo}`,
  getResultadosgestion: () => `${API_BASE_URL}resultadogestion`,
  patchResultadoRescate: () => `${API_BASE_URL}creRescateclientes/updateResultado`,
  gestiones_by_cliente_motivocontinuidad: (sGestionesRecurrentes) => `${API_BASE_URL}gestionesrecurrentes/detalle-gestiones/${sGestionesRecurrentes}`,
  clientes_gestion_base_telefono: (telefono) => `${API_BASE_URL}clientes-gestion-base-telefono/${telefono}`,
  post_cbo_tipocartera: () => `${API_BASE_URL}cbo-tipocartera/new-record`,
  patch_cbo_tipocartera: (id) => `${API_BASE_URL}cbo-tipocartera/update-record/${id}`,
  delete_cbo_tipocartera: (id) => `${API_BASE_URL}cbo-tipocartera/delete-record/${id}`,
  post_BuscaBonoClientesBuenos: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/BuscaBonoClientesBuenos`,
  post_BuscaBonoClientesBuenosCreditos: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/BuscaBonoClientesBuenoscreditos`,
  post_MontoBonoClientesBuenos: () => `${API_BASE_URL}monto-bono-clientes-buenos/find-by-period`,
  get_firma_digital: (id) => `${API_BASE_URL}cre-solicitud-web/firma-digital/${id}`,
  get_firma_digital_cogno: (id) => `${API_BASE_URL}dactilar/find/${id}`,
  getEqfxIdentificacionUAT: (id, uat) => `${API_BASE_URL}eqfxidentificacionconsultada/uat/${id}/${uat}`,
  getUatReporteBuroCreditoUAT: (id, uat) => `${API_BASE_URL}uatEqfxReporteBuroCredito/uat/${id}/${uat}`,

  get_CboRiesgo: () => `${API_BASE_URL}cbo-riesgo/find-all`,
  get_CboAcciones: () => `${API_BASE_URL}cbo-acciones`,
  get_CboCanales: () => `${API_BASE_URL}cbo-canales`,
  get_CboContactos: () => `${API_BASE_URL}cbo-contactos`,
  get_CboResultados: () => `${API_BASE_URL}cbo-resultados`,
  get_CboArbolGestion: () => `${API_BASE_URL}cbo-arbolgestion/find-all`,
  get_CboSiguienteGestion: () => `${API_BASE_URL}cbo-siguiente-gestion/find-all`,
  get_CboEtapasGestion: () => `${API_BASE_URL}cbo-etapas/find-all`,
  get_FactoresComportamiento: () => `${API_BASE_URL}cbo-factores-comportamiento/find-all`,
  get_CboEstrategias: () => `${API_BASE_URL}cbo-estrategias/find-all`,
  get_CboEstrategiasDetalle: () => `${API_BASE_URL}cbo-estrategias-detalle/find-all`,
  get_CboScoringVariables: () => `${API_BASE_URL}cbo-sccoring-variable/find-all`,
  get_CboScoringPesos: () => `${API_BASE_URL}cbo-sccoring-pesos/find-all`,
  get_CboScoringRangos: () => `${API_BASE_URL}cbo-scoring-rangos/find-all`,
  get_CboConfigComportamiento: () => `${API_BASE_URL}cbo-config-comportamiento/find-all`,


  post_CboRiesgo: () => `${API_BASE_URL}cbo-riesgo/create`,
  post_CboAcciones: () => `${API_BASE_URL}cbo-acciones/new-record`,
  post_CboCanales: () => `${API_BASE_URL}cbo-canales`,
  post_CboContactos: () => `${API_BASE_URL}cbo-contactos`,
  post_CboResultados: () => `${API_BASE_URL}cbo-resultados`,
  post_CboArbolGestion: () => `${API_BASE_URL}cbo-arbolgestion/create`,
  post_CboSiguienteGestion: () => `${API_BASE_URL}cbo-siguiente-gestion/create`,
  post_CboEtapasGestion: () => `${API_BASE_URL}cbo-etapas/create`,
  post_CboFactoresComportamiento: () => `${API_BASE_URL}cbo-factores-comportamiento/create`,
  post_CboEstrategias: () => `${API_BASE_URL}cbo-estrategias/create`,
  post_CboEstrategiasDetalle: () => `${API_BASE_URL}cbo-estrategias-detalle/create`,
  post_CboScoringVariables: () => `${API_BASE_URL}cbo-sccoring-variable/create`,
  post_CboScoringPesos: () => `${API_BASE_URL}cbo-sccoring-pesos/create`,
  post_CboScoringRangos: () => `${API_BASE_URL}cbo-scoring-rangos/create`,
  post_CboConfigComportamiento: () => `${API_BASE_URL}cbo-config-comportamiento/create`,

  patch_CboRiesgo: (id) => `${API_BASE_URL}cbo-riesgo/updateCboRiesgo/${id}`,
  patch_CboAcciones: (id) => `${API_BASE_URL}cbo-acciones/update-record/${id}`,
  patch_CboCanales: (id) => `${API_BASE_URL}cbo-canales/updateCboCanales/${id}`,
  patch_CboContactos: (id) => `${API_BASE_URL}cbo-contactos/updateCboContactos/${id}`,
  patch_CboResultados: (id) => `${API_BASE_URL}cbo-resultados/updateCboResultados/${id}`,
  patch_CboArbolGestion: (id) => `${API_BASE_URL}cbo-arbolgestion/${id}`,
  patch_CboSiguienteGestion: (id) => `${API_BASE_URL}cbo-siguiente-gestion/${id}`,
  patch_CboEtapasGestion: (id) => `${API_BASE_URL}cbo-etapas/${id}`,
  patch_CboFactoresComportamiento: (id) => `${API_BASE_URL}cbo-factores-comportamiento/${id}`,
  patch_CboEstrategias: (id) => `${API_BASE_URL}cbo-estrategias/${id}`,
  patch_CboEstrategiasDetalle: (id) => `${API_BASE_URL}cbo-estrategias-detalle/${id}`,
  patch_CboScoringVariables: (id) => `${API_BASE_URL}cbo-sccoring-variable/${id}`,
  patch_CboScoringPesos: (id) => `${API_BASE_URL}cbo-sccoring-pesos/${id}`,
  patch_CboScoringRangos: (id) => `${API_BASE_URL}cbo-scoring-rangos/${id}`,
  patch_CboConfigComportamiento: (id) => `${API_BASE_URL}cbo-config-comportamiento/${id}`,
  post_ticket_new: () => `${API_BASE_URL}cbo-gestores-cobranzas-operativo/insert-ticket/new`,

  get_audit_run: (id) => `${API_BASE_URL}audit-run/${id}`,
  get_audit_msp_aseguradora: (id) => `${API_BASE_URL}audit-msp-aseguradora/${id}`,
  get_audit_supa: (id) => `${API_BASE_URL}audit-supa/${id}`,
  get_audit_satje_causal: (id) => `${API_BASE_URL}audit-satje-causa/${id}`,
};


